import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import GlemtPassord from './pages/GlemtPassord';
import TilbakestillPassord from './pages/TilbakestillPassord';
import Dashboard from './pages/Dashboard';
import Eiendom from './pages/Eiendom';
import Befaring from './pages/Befaring';
import BygningsdelBefaring from './pages/BygningsdelBefaring';
import Kontrollsenter from './pages/Kontrollsenter';
import Rapport from './pages/Rapport';
import './App.css';

// ProtectedRoute komponent
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading-screen">Laster...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
}

// PublicRoute komponent (redirecter til dashboard hvis allerede logget inn)
function PublicRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading-screen">Laster...</div>;
  }

  return !isAuthenticated ? children : <Navigate to="/dashboard" />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        }
      />
      <Route
        path="/glemt-passord"
        element={
          <PublicRoute>
            <GlemtPassord />
          </PublicRoute>
        }
      />
      <Route
        path="/tilbakestill-passord/:token"
        element={
          <PublicRoute>
            <TilbakestillPassord />
          </PublicRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/eiendom/:id"
        element={
          <ProtectedRoute>
            <Eiendom />
          </ProtectedRoute>
        }
      />
      <Route
        path="/befaring/:romId"
        element={
          <ProtectedRoute>
            <Befaring />
          </ProtectedRoute>
        }
      />
      <Route
        path="/bygningsdel-befaring/:id"
        element={
          <ProtectedRoute>
            <BygningsdelBefaring />
          </ProtectedRoute>
        }
      />
      <Route
        path="/kontrollsenter/:eiendomId"
        element={
          <ProtectedRoute>
            <Kontrollsenter />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rapport/:id"
        element={
          <ProtectedRoute>
            <Rapport />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
